// components
import Autocomplete from '@material-ui/lab/Autocomplete';
import Input from '../Input';

// hooks
// import { useDivisionState } from 'providers/DivisionProvider';
import { useAllDivisionsByCustomer } from 'hooks/divisions';
import { useEffect, useState } from 'react';

// lib
// import { setDivisionInStorage } from 'lib/Storage';

/**
 * @component SelectDivision
 */
function SelectDivision({
  value,
  selectedBranch,
  setSelectedDivision,
  setSelectedService,
  readOnly,
  ...rest
}) {
  // const [division, setDivision] = useDivisionState();
  const changeDivisionHandler = (event, value) => {
    // const newDivision = { ...division, selected: value };
    // setDivision(newDivision);
    // setDivisionInStorage(newDivision);
    setSelectedDivision(value);
    setSelectedService('');
  };

  const { data, isLoading } = useAllDivisionsByCustomer('');
  const [filteredDivisions, setFilteredDivisions] = useState('');
  const [isFilteredDivisionsReady, setISFilteredDivisionsReady] = useState(false);

  useEffect(() => {
    if (!data || !data.divisions) return;

    let filteredData = data?.divisions
      ?.filter((division) => {
        let branch = division.title.split('-')[0].trim();
        return branch === selectedBranch.titleID;
      })
      .map((division) => {
        return { ...division, title: division.title.split('-')[1].trim() };
      });

    setFilteredDivisions(filteredData);
  }, [data, selectedBranch]);

  useEffect(() => {
    if (filteredDivisions) setISFilteredDivisionsReady(true);
  }, [filteredDivisions]);

  return (
    <Autocomplete
      disablePortal
      // value={value}
      loading={isLoading || !isFilteredDivisionsReady}
      onChange={changeDivisionHandler}
      filterSelectedOptions
      disabled={readOnly}
      getOptionSelected={(option, value) => value?._id === option?._id}
      // options={data?.divisions ? data?.divisions : []}
      options={filteredDivisions ? filteredDivisions : []}
      getOptionLabel={(option) => (option?.title ? option?.title : '')}
      renderInput={(params) => <Input label="انتخاب بخش" {...params} fullWidth />}
      {...rest}
    />
  );
}

export default SelectDivision;
